export enum EDiscountStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  EXPIRED = 'EXPIRED', // Computed
  SCHEDULED = 'SCHEDULED' // Computed: активна, но дата начала ещё не наступила
}

export enum EDiscountTargetType {
  GLOBAL = 'GLOBAL', // все товары продавца
  SPECIFIC = 'SPECIFIC'
}

// Скидка меняет реальные цены товаров: текущая цена уходит в f_price (full price),
// price = full price * (1 - discount_value/100)
// seller_id приходит с populate (shop_details) для колонки «Продавец» у админа
export interface IDiscountSeller {
  _id: string
  shop_details?: {
    shop_name?: string
  }
}

export interface IDiscount {
  _id: string
  name: string
  discount_value: number
  start_date: string
  end_date: string
  status: EDiscountStatus
  seller_id: string | IDiscountSeller
  target_type: EDiscountTargetType
  target_subcategories: string[]
  target_products: string[]
  is_applied: boolean
  applied_product_ids: string[]
  isExpired: boolean
  isScheduled?: boolean
  // считается бэкендом при каждом запросе; null — у архивной и истёкшей
  products_count?: IDiscountProductsCount | null
  createdAt: string
  updatedAt: string
}

// total — товары скидки, on_sale — из них опубликованные и с остатком на складе.
// У применённой скидки это её набор товаров, у ещё не применённой — прогноз
export interface IDiscountProductsCount {
  total: number
  on_sale: number
}

export interface IPreviewDiscountProducts {
  target_type: EDiscountTargetType
  target_subcategories?: string[]
  target_products?: string[]
  seller_id?: string
  // при правке товары этой же скидки считаются свободными
  discount_id?: string
}

export interface ICreateDiscount {
  name: string
  discount_value: number
  start_date: string
  end_date: string
  target_type: EDiscountTargetType
  target_subcategories?: string[]
  target_products?: string[]
  seller_id?: string
}

export interface IGetDiscountsQuery {
  skip: string
  limit: string
  name?: string
  status?: EDiscountStatus
  seller_id?: string
}

export interface IGetDiscountsResponse {
  items: IDiscount[]
  count: number
}

export interface IUpdateDiscountStatus {
  status: EDiscountStatus
}
